<template>

  <div class="modal fade" id="AddSecteurModal" tabindex="-1" role="dialog" ref="addSecteurModalRef" aria-labelledby="tooltipmodal" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered" role="Secteur">
              <div class="modal-content">
                  <div class="modal-header">
                      <h4 class="modal-title">{{ title }}</h4>
                      <button class="btn-close py-0" type="button" data-bs-dismiss="modal" aria-label="Close"></button>
                  </div>
                  <div class="modal-body">
                    <Form ref="secteurForm" @submit="addSecteur" :validation-schema="secteurSchema">
                      <div class="row">
                        <div class="col-md-12 mb-3">
                          <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                              Code <span class="text-danger">*</span>
                            </label>
                            <Field name="code" type="text" 
                            class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le code"/>
                            <ErrorMessage name="code" class="text-danger"/>
                          </div>     
                        </div>
                        
                        <div class="col-md-12 mb-3">
                          <div class="form-group mb-15 mb-sm-20 mb-md-25">
                            <label class="d-block text-black fw-semibold mb-10">
                              Libelle <span class="text-danger">*</span>
                            </label>
                            <Field name="libelle" type="text" 
                            class="form-control shadow-none fs-md-15 text-black" placeholder="Entrer le libelle"/>
                            <ErrorMessage name="libelle" class="text-danger"/>
                          </div>     
                        </div>
                    
                        <button
                          class="btn btn-primary"
                          type="submit">
                          {{ btntext }}
                        </button>
                      </div>
                    </Form>
                  </div>
               
              </div>
          </div>
      </div>
  </template> 
  
  <script lang="ts">
  import { ref, watch } from 'vue';
  import { Form, Field, ErrorMessage } from 'vee-validate';
  import * as Yup from 'yup';
  import ApiService from '@/services/ApiService';
  import { error, hideModal, success } from '@/utils/utils';
  import { Secteur } from '@/models/Secteur';
  import { useRouter } from 'vue-router';
  
  export default {
    name: "AddSecteurModal",
    components: {
      Form,
      Field,
      ErrorMessage
    },
    props:{
      id: {
        type: Number,
        required: true,
        default:0
      },
    },
    emits: ["refreshSecteurs",'openmodal'],
  
    setup: (props: any, { emit }: { emit: (event: string, payload?: any) => void }) => {

      const loading = ref<boolean>(false);
      const secteurSchema = Yup.object().shape({
        libelle: Yup.string().required('Le libelle est obligatoire'),
        code: Yup.string().required('Le code est obligatoire'),

      });
  
  
      const secteurnew = ref(props.id);
      const secteurForm =  ref<Secteur | null>(null);
      const addSecteurModalRef = ref<null | HTMLElement>(null);
      let secteurs= ref<Array<Secteur>>([]);
      const title = ref('Ajouter un secteur ');
      const btntext = ref('Ajouter');
      const isupdate=ref(false);
      const router = useRouter();
  
      watch(() => props.id , (newValue) => {   
        if (newValue!=0) {
          getSecteur(newValue);
          isupdate.value=true;
        }
        btnTitle();
      });
  
      const getSecteur = async (id: number) => {
        return ApiService.get("/secteurs/"+id)
        .then(({ data }) => {
          secteurForm.value?.setFieldValue("id",data.data.id);
          secteurForm.value?.setFieldValue("libelle",data.data.libelle);
          secteurForm.value?.setFieldValue("code", data.data.code);
          emit('openmodal', addSecteurModalRef.value);
        })
        .catch(({ response }) => {
          error(response.data.message)
        });
      }
  
      const btnTitle = async () => {
        if (isupdate.value) {
           title.value = "Modifier le secteur";
           btntext.value = "Modifier";
        }else{
           title.value = "Ajouter un secteur ";
           btntext.value = "Ajouter";
        }
      }
  
      const addSecteur = async (values:any, {resetForm}: {resetForm: () => void  }) => {
        values = values as Secteur;
        loading.value = false;
        if(isupdate.value) {
          ApiService.put(`/secteurs/${values.id}`,values)
          .then(({ data }) => {
            if(data.code == 200) { 
              success(data.message);
              resetForm();
              hideModal(addSecteurModalRef.value);
              isupdate.value=false;
              btnTitle();
              emit("refreshSecteurs");
              router.push('/liste-secteur');
            }
          }).catch(({ response }) => {
            error(response.data.message);
          });
        }else{
          ApiService.post("/secteurs",values)
          .then(({ data }) => {
            if(data.code == 201) { 
              success(data.message)
              resetForm();
              hideModal(addSecteurModalRef.value);
              emit("refreshSecteurs");
  
            }
          }).catch(({ response }) => {
            error(response.data.message);
          });
        }
      }; 
  
      const resetValue = () => {
        const formFields = document.querySelectorAll<HTMLInputElement | HTMLTextAreaElement>('input, textarea');
        isupdate.value=false;
        formFields.forEach(field => {
          field.value = '';
        });
        btnTitle()
      };
  
      return {secteurs, title,btntext, resetValue, secteurSchema,
         addSecteur, secteurForm,addSecteurModalRef,secteurnew,
         };
    },
  };
  </script>@/models/Secteur